<template>
    <div class="d-flex align-items-center flex-wrap">
        <div class="selected-appointment-day">
            <div class="day-date">
                <span>{{date.day}}</span>
                <span class="day-name">{{date.month}}</span>
            </div>
            <div>
                <div class="info-name">Interview</div>
                <div class="info">
                    {{date.weekday}} {{date.start_interview}} - {{date.end_interview}}
                </div>
            </div>
        </div>
        <button
            class="red-link"
            @click="showCustomModal('deleteInterview', appointmentInfo.id)"
            v-show="!hideDeleting"
        >
            Cancel Your Appointment
        </button>
        <ActionModal confirm-text="Yes" reject-text="No"
                     :modalId="getCustomModalId('deleteInterview', appointmentInfo.id)"
                     @confirm="deleteEvent">
            <template #body>
                <div class="text-center mb-4">
                    <h4>
                        Do you want  <br> to delete the appointment?
                    </h4>
                </div>
            </template>
        </ActionModal>
    </div>
</template>

<script>
import moment from "moment";
import ModalHandler from "../../../../../../../resources/js/mixins/ModalHandler";
import ActionModal from "../../../../../../../resources/js/components/ActionModal.vue";
import AppointmentService from "../../services/AppointmentService";

export default {
    name: 'SelectedSlot',
    components: {ActionModal},
    mixins: [ModalHandler],
    emits: ['update-interview'],
    props: {
        appointmentInfo: {
            type: Object,
            required: false,
        },
        hideDeleting: {
            type: Boolean
        }
    },
    data() {
        return {
            date: {
                day: null,
                month: null,
                dayOfWeek: null,
                weekday: null,
                start_interview: null,
                end_interview: null,
            }
        }
    },
    methods: {
        async deleteEvent() {
            this.$showLoadingMessage()
            try {
                await AppointmentService.deleteCurrentAppointment(this.appointmentInfo.id)
                this.$emit('update-interview')
                this.$showSuccessMessage('Selected appointment was deleted')
            } catch {
                this.$showErrorMessage('Selected appointment was not deleted. Please contact to manager')
            }
        },
        parseDate() {
            const timeForParsingStart = moment(this.appointmentInfo.start_date)
            const timeForParsingEnd = moment(this.appointmentInfo.end_date)
            this.date.weekday = timeForParsingStart.format('ddd');
            this.date.day = timeForParsingStart.format('D');
            this.date.month = timeForParsingStart.format('MMM');
            this.date.start_interview = timeForParsingStart.format('hh:mm a')
            this.date.end_interview = timeForParsingEnd.format('hh:mm a')

        },
    },
    mounted() {
        this.parseDate()
    }

}


</script>


<style scoped>

</style>
